

<div class="d-flex justify-content-center align-items-center footer">
    <p class="fs-14 mb-0" >{{staticText?.login?.login_grow_text}} {{currentYear}}{{staticText?.login?.login_copyrights_year}}{{staticText?.login?.login_copyrights}}</p>
</div>